// extracted by mini-css-extract-plugin
export default {"column":"SignUp_column__C3stb","formHeader":"SignUp_formHeader__w7RZD","authLinks":"SignUp_authLinks__HZpk-","logoLink":"SignUp_logoLink__IWy3E","appLogo":"SignUp_appLogo__tJGhI"};